import Table from "../../../components/Table/Table";
import Badge from "../../../components/Badge";

const ReferralReferredUsers = ({ referrers, isReferrersLoading }) => {
  const referrerColumns = [
    { name: "Name", selector: row => row.school_name || row.name || `${row.first_name || ""} ${row.last_name || ""}`, sortable: true },
    { name: "Primary Email", selector: row => row.email || row.school_email, sortable: true },
    { name: "Status", selector: row => row.status || "Pending", sortable: true, cell: row => <Badge status={row.status || "Pending"} /> },
    { name: "Date created", selector: row => row.created_at ? new Date(row.created_at).toLocaleDateString() : "N/A", sortable: true }
  ];

  return (
    <main className="ref-dash-main ref-settings-main">
      <div className="ref-settings-card" style={{ padding: "32px 0" }}>
        <div className="ref-referrers-section" style={{ marginTop: 0, border: "none", padding: "0 32px" }}>
          <div className="ref-table-header">
            <div className="ref-table-title">
              <h2>All Referred Users</h2>
              <p>See all the users you have referred</p>
            </div>
          </div>

          <Table data={referrers || []} columns={referrerColumns} pagination isLoading={isReferrersLoading} />
        </div>
      </div>
    </main>
  );
};

export default ReferralReferredUsers;
